'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var ReactDOM = _react2['default'].version >= '0.14.0' ? _reactDom2['default'] : _react2['default'];

exports['default'] = ReactDOM;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-slick/lib/mixins/ReactDOM.js
// module id = 915
// module chunks = 1